import React from "react";
import CardClass from "../../../CardClass";
import Table from "../../../Table";
import { withRouter } from "react-router-dom";
import MUITextField from "@mui/material/TextField";
import MUIInputAdornment from "@mui/material/InputAdornment";
import MUISearchIcon from "@mui/icons-material/Search";
import api from "../../../../Seating/Security/api";
import DiagnosisCode from "../../../../Utility/Crud/DiagnosisCode";
import Throttle from "../../../../Utility/Throttle";

export default withRouter(
  class CardAdminDiagnosisCodeList extends CardClass {
    constructor(props) {
      super(props);
      this.state = {
        diagnosisCodes: [],
        currentSearchId: 0,
      };
      this.throttledHandleSearchChange = Throttle.throttle(
        this.handleSearchChange.bind(this),
        100,
        { trailing: true },
      );
    }

    handleSearchChange(event) {
      // Makes sure only the most recent search result is rendered
      const searchId = this.state.currentSearchId + 1;
      this.setState({ currentSearchId: searchId });

      if (event.target.value) {
        api
          .send("POST", "/search/omniSearch/DiagnosisCode", {
            omniSearchTerm: event.target.value,
            recordLimit: 20,
          })
          .then((data) => {
            if (this.state.currentSearchId === searchId) {
              this.setState({
                diagnosisCodes: data.diagnosisCodes.map((diagnosisCode) => ({
                  ...diagnosisCode,
                  code: DiagnosisCode.getDisplayName(diagnosisCode),
                })),
              });
            }
          })
          .catch((error) => {
            console.error(error);
            if (this.state.currentSearchId === searchId) {
              this.setState({ diagnosisCodes: [] });
            }
          });
      } else {
        this.setState({ diagnosisCodes: [] });
      }
    }

    renderContent() {
      return (
        <>
          <MUITextField
            autoFocus={true}
            placeholder="Type to search..."
            hiddenLabel={true}
            fullWidth={true}
            variant="filled"
            size="small"
            sx={{
              marginBottom: 2,
              "& .MuiInputLabel-root": { display: "none", height: 0 },
            }}
            onChange={this.throttledHandleSearchChange}
            slotProps={{
              input: {
                startAdornment: (
                  <MUIInputAdornment position="start">
                    <MUISearchIcon />
                  </MUIInputAdornment>
                ),
                disableUnderline: true,
                style: { borderRadius: 4 },
              },
            }}
          />
          <Table
            search={false}
            columns={[
              { key: "code", name: "Code", type: "string", width: 150 },
              { key: "descriptionShort", name: "Description", type: "string" },
            ]}
            rows={this.state.diagnosisCodes}
            onClick={(diagnosisCode) => {
              this.props.history.push({
                pathname: "/admin/diagnosisCode/" + diagnosisCode.id,
              });
            }}
          />
        </>
      );
    }
  },
);
